/**
 * Fix for TypeError: Cannot set properties of null (setting 'checked')
 * 
 * This script prevents the error that occurs when app.js CheckAll class
 * tries to manage checkboxes with the 'checks' class but the expected
 * 'checkAll' or 'checkLocationAll' elements don't exist on the page.
 * 
 * Solution: Remove the 'checks' class from checkboxes on pages that use
 * different "check all" IDs (like checkAllOccupation, checkAllPrefecture)
 * to prevent app.js from trying to manage them.
 */

document.addEventListener('DOMContentLoaded', function() {
  // Check if we're on a page with custom "check all" checkboxes
  const hasCustomCheckAll = document.getElementById('checkAllOccupation') || 
                           document.getElementById('checkAllPrefecture') ||
                           document.getElementById('checkAllSubject');
  
  // If we have custom check all elements, remove the 'checks' class
  // from individual checkboxes to prevent app.js from managing them
  if (hasCustomCheckAll) {
    const checkboxes = document.querySelectorAll('.checks');
    checkboxes.forEach(function(checkbox) {
      checkbox.classList.remove('checks');
    });
  }
});
